import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const ClockIcon: FC<SvgProps> = (props) => {
    return (
        <Svg viewBox="0 0 16 16" height={16} width={16} {...props}>
            <Path
                fill={ColorEnum.EMERALD_500}
                d="M9.394 10.603c.16.165.356.247.588.247a.84.84 0 0 0 .612-.264.81.81 0 0 0 0-1.207L8.84 7.634V5.572c0-.227-.08-.42-.242-.582a.813.813 0 0 0-.6-.243.809.809 0 0 0-.592.25.802.802 0 0 0-.249.586v2.38a.917.917 0 0 0 .263.625l1.974 2.015ZM8 14.987a6.82 6.82 0 0 1-2.732-.55 7.044 7.044 0 0 1-2.215-1.49 7.044 7.044 0 0 1-1.491-2.215A6.82 6.82 0 0 1 1.011 8c0-.972.184-1.883.55-2.732a7.044 7.044 0 0 1 1.491-2.214 7.044 7.044 0 0 1 2.215-1.491 6.82 6.82 0 0 1 2.732-.55 6.82 6.82 0 0 1 2.731.55 7.045 7.045 0 0 1 2.215 1.49 7.044 7.044 0 0 1 1.491 2.215c.367.85.55 1.76.55 2.732a6.82 6.82 0 0 1-.55 2.732 7.044 7.044 0 0 1-1.49 2.215 7.046 7.046 0 0 1-2.216 1.49c-.848.367-1.759.55-2.731.55Zm-.004-1.833c1.426 0 2.643-.5 3.649-1.5 1.005-1 1.508-2.217 1.508-3.65 0-1.433-.501-2.65-1.504-3.653-1.003-1.003-2.218-1.504-3.645-1.504s-2.643.5-3.65 1.5c-1.005 1-1.508 2.216-1.508 3.65 0 1.432.502 2.65 1.505 3.653 1.003 1.002 2.218 1.504 3.645 1.504Z"
            />
        </Svg>
    )
}

export default ClockIcon
